import { createSelector } from 'reselect';

const getAlertsObject = (state) => {
  return state.alerts || {};
};

const _getAlerts = createSelector(
  getAlertsObject,
  (state, props = {}) => ({
    id: props.id,
  }),
  (alerts, { id }) => {
    return alerts.shipper_order[id];
  }
);

export const getAlerts = createSelector(_getAlerts, (alerts = []) => {
  return alerts;
});
